import React, { createContext, useContext, useEffect, useState } from 'react';
import { getApiUrl } from '../lib/api';

const SettingsContext = createContext({ settings: null, loading: true });

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetch(`${getApiUrl()}/api/settings`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (active) {
          setSettings(d);
          setLoading(false);
        }
      })
      .catch(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);

export const buildTvaLine = (settings) => {
  if (!settings || !settings.tva_enabled) return null;
  if (settings.tva_text && settings.tva_text.trim()) return settings.tva_text.trim();
  if (settings.tva_regime === 'franchise') {
    return 'TVA non applicable, article 293 B du CGI.';
  }
  const rates = settings.tva_rates && settings.tva_rates.trim();
  return rates
    ? `Prix indiqués HT. TVA applicable selon la nature des travaux (${rates}).`
    : 'Prix indiqués HT. TVA applicable selon la nature des travaux.';
};
